import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-card-media-with-slider-losaprily.js';

const html = `
<div class="container">
  <div data-attribute="title-des-content-desktop" class="title-des-content-desktop">
    <h2>Mókás és játékos dizájn</h2>
    <p>Tedd a medencézést felejthetetlen élménnyé ezekkel az izgalmas funkciókkal.</p>
  </div>
  <div class="wrap-card" data-attribute="wrap-card" data-grap-card="30" style="--grap-card:30px">
    <div class="wrap-media" data-use-media="video" data-attribute="wrap-media" data-order="1" style="--order-media:1">
      <div class="wrap-video">
        <video data-attribute="video-card" autoplay loop muted playsinline
          src="https://cdn.shopify.com/videos/c/o/v/52919599fc7e42d4b7529ac81bc715e0.mp4"></video>
      </div>
      <div class="wrap-image" style="display: none;">
        <img data-attribute="image-card" src="" alt="">
      </div>
    </div>
    <div class="wrap-content" data-attribute="wrap-content" data-order="2" style="--order-content:2">
      <div data-attribute="title-des-content" class="title-des-content">
        <h2>Mókás és játékos dizájn</h2>
        <p>Tedd a medencézést felejthetetlen élménnyé ezekkel az izgalmas funkciókkal.</p>
      </div>
      <div class="block-swiper">
        <div class="swiper">
          <div data-attribute="list-item" class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="wrap-item-slide">
                <div class="wrap-img-item">
                  <img data-attribute="img-item"
                    src="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3c8aced0f7a159b837576c.webp" alt="">
                </div>
                <div data-attribute="content-item" class="content-item">
                  <h3 style="text-align: center;">Kormány dudával</h3>
                  <p style="text-align: center;">Figyelemfelkeltő árnyalatok, amelyek azonnal elvarázsolják a kicsiket.
                  </p>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="wrap-item-slide">
                <div class="wrap-img-item">
                  <img data-attribute="img-item"
                    src="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3c8b062117101b27ad2af4.webp" alt="">
                </div>
                <div data-attribute="content-item" class="content-item">
                  <h3 style="text-align: center;">Kormány dudával</h3>
                  <p style="text-align: center;">Figyelemfelkeltő árnyalatok, amelyek azonnal elvarázsolják a kicsiket.
                  </p>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="wrap-item-slide">
                <div class="wrap-img-item">
                  <img data-attribute="img-item"
                    src="https://cdn.skyfastimg.com/images/2026/06/25/image-6a3c8b1f72f2902bac4e1029.webp" alt="">
                </div>
                <div data-attribute="content-item" class="content-item">
                  <h3 style="text-align: center;">Kormány dudával</h3>
                  <p style="text-align: center;">Figyelemfelkeltő árnyalatok, amelyek azonnal elvarázsolják a kicsiket.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="group-navigation-swiper">
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css);
